import { prepareArtifacts } from "./artifacts.js";
import { prepareDataSpecification } from "./data-specification.js";
import { prepareFunctions } from "./functions.js";
/**
 * Default mustache view reducers
 */
export const defaultMustacheViewReducers = [
    prepareFunctions,
    prepareArtifacts,
    prepareDataSpecification,
];
/**
 * Returns the mustache view for the template
 */
export function getMustacheView(context, adapter) {
    return defaultMustacheViewReducers.reduce((view, reducer) => reducer(view, context, adapter), {});
}
//# sourceMappingURL=views.js.map